<template>
  <div class="News" style="zoom:80%">
    <!-- <div class="news_banner"><h3>获取一手新鲜资讯，了解我们</h3></div> -->
    <div class="wrap">
    <!--   <swiper class="news_swiper" style="zoom:80%" :options="swiperOption" ref="mySwiper">
        <swiper-slide> 
          <router-link to="newsdetails/8" class="flex">
          <div class="img">
            <img src="../assets/img/news/detail/81.png" />
            <p>八月专题新闻</p>
          </div>
        </router-link>
        </swiper-slide>
        <swiper-slide style="display: flex;justify-content: center;align-items: center;">
          <router-link to="newsdetails/6" class="flex">
          <div  class="img">
            <img src="../assets/img/news/detail/61.png" />
            <p>六月专题新闻</p>
          </div>
        </router-link>
        </swiper-slide>
        <div class="swiper-pagination " slot="pagination"></div>
      </swiper> -->
      <div class="page_tit_news">
        最新新闻
      </div>
      <ul class="news_list">
        <li v-for="item in List" :key="item">
          <router-link :to="'/newsdetails/' + item.id" class="flex">
            <div class="img"><img :src="item.img"/></div>
            <div class="text">
              <div class="txt">
                <p v-html="item.text2">
                 </p>
              </div>
              <div class="des">
                <span v-html="item.title"></span><span v-html="item.publishdate"></span>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
      <div class="ht50"></div>
      <div class="more_news"><a href="#">更多新闻</a></div>
      <div class="ht50"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChangeEnd: function() {},
        },
      },
      List: [
      {
          id: 8,
          img: "detail/81.png",
          title: "八月专题新闻",
          publishdate: "2024.8.2",
          text2:
            "UC-ELINK推动中英之间高端人才交流，于八月十四至十五日，协助推动由华威大学副校长，...",
        },
      {
          id: 6,
          img: "detail/61.png",
          title: "六月专题新闻",
          publishdate: "2024.7.2",
          text2:
            "UC-ELINK和中国本土最大猎头公司嘉驰国际合作，正式推出中国留学生一对一择业...",
        },
      {
          id: 5,
          img: "detail/51.png",
          title: "五月专题新闻",
          publishdate: "2024.6.2",
          text2:
            "UC-ELINK和英国最大的留学生社群红杉学社建立战略合作关系，双方将在人才服务，...",
        },
      {
          id: 3,
          img: "detail/31.png",
          title: "三月专题新闻",
          publishdate: "2024.4.3",
          text2:
            "UC-ELINK和中国本土最大猎头公司嘉驰国际建立战略合作关系，双方将合作，将针...",
        },
      {
          id: 2,
          img: "detail/2.png",
          title: "二月专题新闻",
          publishdate: "2024.3.1",
          text2:
            "UC-ELINK和中国人力资源行业领先媒体公司HRoot建立战略合作关系，双方将在人...",
        },
        {
          id: 1,
          img: "detail/1.png",
          title: "一月专题新闻",
          publishdate: "2024.2.6",
          text2:
            "UC-ELINK和全球知名猎头公司Hudson建立战略合作关系。双方将着眼于人才服务领...",
        }, 
      ]
    };
  },
  computed: {
    ProList() {
      return [
        {
          img: require("../assets/img/contactus/picture2.jpg"),
          tit: this.$t("others.kouhao"),
          des: "",
        },
      ];
    },
  },
  components: {},
  created() {},
};
</script>

<style lang="scss" scoped></style>
